import type { ProductPricingEntity } from "@features/checkout/domain";
import type { ProductEntity } from "@features/products/domain";

export const mergeProductPricingDetails = (
  products: ProductEntity[],
  productsPricingDetails: ProductPricingEntity[],
): ProductEntity[] => {
  return products.map(product => ({
    ...product,
    financials: {
      ...product.financials,
      profit:
        productsPricingDetails.find(detail => detail.sku === product.sku)
          ?.profit || product.financials.profit,
    },
  }));
};
